module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-406.7a9d44a.woff2";